<template>
  <div class="download-container">
    <div class="download-platform" v-if="isWeixin && isAndroid">
      <div class="download-tips">
        <img src="@/assets/img/download-tips.png" />
      </div>
    </div>
    <div class="header">
      <img class="app-logo" src="@/assets/img/app_logo.png" />
      <div class="info">
        <span class="slogan">边境贸易 互联互通</span>
        <span class="eg">BORDER TRADE,INTERCONNECTION</span>
      </div>
    </div>
    <div class="body">
      <img class="app-bg-banner" src="@/assets/img/app-bg-banner.png" />
      <div class="download-btn">
        <a class="btn" v-if="isIos" target="_blank" :href="iosUrl">
          <span class="txt">去App Store 下载</span>
        </a>
        <div class="btn" v-if="isAndroid" @click="androidDownload">
          <span class="txt">点击下载</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { appVersion } from "@/api/app.js";
export default {
  data() {
    return {
      isWeixin: false,
      isAndroid: false,
      isIos: false,
      iosUrl:
        "https://apps.apple.com/cn/app/%E8%BE%B9%E4%BA%92%E9%80%9A/id1500549596",
      androidUrl: "/download"
    };
  },
  created() {
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    this.isWeixin = isWeixin;
    let isAndroid = ua.indexOf("android") != -1;
    this.isAndroid = isAndroid;
    let isIos = ua.indexOf("iphone") != -1 || ua.indexOf("ipad") != -1;
    this.isIos = isIos;

    if (!this.isAndroid && !isIos) {
      alert("请在手机端打开");
    }
    appVersion()
      .then(res => {
        this.androidUrl = res.data.downloadUrl;
      })
      .catch(error => {
        alert("请求出错！");
        console.log(error);
      });
  },
  methods: {
    androidDownload() {
      location.href = this.androidUrl;
    }
  }
};
</script>
<style lang="scss" scoped>
.download-container {
  position: relative;
  height: 100vh;
  background: linear-gradient(
    324deg,
    rgba(31, 126, 254, 1) 0%,
    rgba(18, 184, 246, 1) 100%
  );
  .download-platform {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.7);
    .download-tips {
      margin-top: 36px;
      display: flex;
      justify-content: center;
      img {
        width: 647px;
        height: 446.88px;
      }
    }
  }
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 443px;

    .app-logo {
      margin-top: 80px;
      width: 276.05px;
      height: 82.19px;
    }
    .info {
      margin-top: 85px;
      display: flex;
      flex-direction: column;
      text-align: center;
      .slogan {
        font-size: 58px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        // letter-spacing: 40px;
        opacity: 1;
      }
      .eg {
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        // letter-spacing: 40px;
      }
    }
  }
  .body {
    position: relative;
    height: 901px;
    .app-bg-banner {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .download-btn {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      .btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 77px;
        width: 587px;
        height: 86px;
        border: 1px solid rgba(177, 83, 0, 1);
        text-decoration: none;
        background: linear-gradient(
          180deg,
          rgba(250, 157, 105, 1) 0%,
          rgba(255, 14, 14, 1) 100%
        );
        box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 43px;

        .txt {
          font-size: 30px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 33px;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
  }
}
</style>
